
const Hero = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/fd52602a17c64459a54e64520dab6dec.jpeg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-3xl sm:text-4xl lg:text-7xl font-light mb-6 leading-tight">
            Um lugar para
            <br />
            <span className="font-normal">respirar e se reconectar</span>
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl mb-8 max-w-3xl mx-auto font-light leading-relaxed">
            Descubra a tranquilidade que você procura em nossa casa de sítio, 
            onde o tempo desacelera e a natureza acolhe
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a 
              href="https://www.airbnb.com.br/rooms/553742770278089580?adults=4&children=0&infants=0&pets=0&wishlist_item_id=11001891367868&source_impression_id=p3_1760814757_P3Fwo7oINHF-zbvZ&previous_page_section_name=1000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-stone-100 text-stone-800 px-4 py-2 rounded-full text-sm font-medium hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Ver Disponibilidade
            </a>
            <a 
              href="https://wa.me/5545991110033?text=Olá! Gostaria de saber mais sobre a Casa do Campo para locação por temporada."
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-white hover:text-stone-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Fale Conosco
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
